import { WZUtils, XBrowser, XUtils, XTemplate } from '../common/globals'

export const {
  isNumber,
  isPlain,
  isString,
  isArray,
  isFunction,
  isBoolean,
  isUndefined,
  q2o,
  o2q,
  assign,
  forEach,
  forIn,
  trim,
  text2time,
  text2date
} = XUtils

export const { compile, render, helper } = XTemplate

const _time2text = XUtils.time2text

export const { getServerTime, isInWZApp, isInWeiXin } = WZUtils

export const { getStorage, setStorage } = XBrowser

// export { getStorage, setStorage };

export const keys = Object.keys //

export function isNumeric(n) {
  return (
    (isNumber(n) && isFinite(n)) ||
    (isString(n) && /^[+-]?\d+(\.\d+)?$/.test(n))
  )
}

export function isNil(value) {
  return value === undefined || value === null
}

export function isOkId(id) {
  return id > 0 && /^\d+$/.test('' + id)
}

export function isOkIds(ids) {
  return /^[1-9]\d*(,[1-9]\d*)*$/.test('' + ids)
}

export function isOkMin(min) {
  return /^\d\d\d\d$/.test(min)
}

export function time2text(time, format) {
  format = format || 'MM月DD日hh:mm'
  return _time2text(time, format)
}

export function isBefore(time) {
  return getServerTime() < time
}

export function isAfter(time) {
  return time > 0 && getServerTime() >= time
}

export function isBetween(beginTime, endTime) {
  const now = getServerTime()
  return now >= beginTime && now < endTime
}

export function map(it, fn) {
  let R = []
  if (isArray(it)) {
    forEach(it, (v, i) => R.push(fn(v, i)))
  } else if (isPlain(it)) {
    R = {}
    forIn(it, (v, i) => (R[i] = fn(v, i)))
  }
  return R
}

export function filter(it, fn) {
  let R = []
  if (isArray(it)) {
    forEach(it, (v, i) => {
      if (fn(v, i)) {
        R.push(v)
      }
    })
  } else if (isPlain(it)) {
    R = {}
    forIn(it, (v, i) => {
      if (fn(v, i)) {
        R[i] = v
      }
    })
  }
  return R
}

export function some(a, pred) {
  return findIndex(a, pred) > -1
}

export function has(it, key) {
  return !!it && it.hasOwnProperty(key)
}

export function prop(obj, key, defaultValue) {
  return !isNil(obj) && has(obj, key) ? obj[key] : defaultValue
}

export function last(list, defaultValue) {
  const idx = list && list.length > 0 ? list.length - 1 : -1
  return idx >= 0 && !isNil(list[idx]) ? list[idx] : defaultValue
}

export const isNaN = isFunction(Number.isNaN)
  ? Number.isNaN
  : function(n) {
      // eslint-disable-next-line
      return n !== n
    }

function makeEqPred(a) {
  return isNaN(a) ? isNaN : v => v === a
}

export function findIndex(a, pred) {
  for (let i = 0, length = a.length; i < length; i++) {
    if (pred(a[i], i)) {
      return i
    }
  }
  return -1
}
export function findLastIndex(a, pred) {
  for (let i = a.length - 1; i >= 0; i--) {
    if (pred(a[i], i)) {
      return i
    }
  }
  return -1
}

export function find(a, pred) {
  const i = findIndex(a, pred)
  return i < 0 ? undefined : a[i]
}

export function findLast(a, pred) {
  const i = findLastIndex(a, pred)
  return i < 0 ? undefined : a[i]
}

export function inArray(a, v) {
  return findIndex(a, makeEqPred(v)) > -1
}

export function array2map(it, pkey) {
  const R = {}
  forEach(it, o => {
    if (o && o[pkey]) {
      R[o[pkey]] = o
    }
  })
  return R
}

export function leftSecs(nowTime, endTime) {
  return nowTime > endTime ? 0 : Math.ceil((endTime - nowTime) / 1000)
}

export function now() {
  return getServerTime()
}

export function pad(n) {
  return n < 10 ? '0' + n : n
}
export function sec2obj(s) {
  var days = 0
  var hours = 0
  var minutes = 0
  var seconds = 0
  s = s > 0 ? s : 0
  seconds = Math.ceil(s)
  if (seconds >= 60) {
    minutes = Math.floor(seconds / 60)
    seconds = seconds % 60
  }
  if (minutes >= 60) {
    hours = Math.floor(minutes / 60)
    minutes = minutes % 60
  }
  if (hours >= 24) {
    days = Math.floor(hours / 24)
    hours = hours % 24
  }

  return { days, hours, minutes, seconds }
}
export function sec2txt(seconds, mode) {
  var d = 0
  var h = 0
  var m = 0
  var s = 0
  var R = ''
  seconds = seconds > 0 ? seconds : 0
  s = Math.ceil(seconds)
  if (s >= 60) {
    m = Math.floor(s / 60)
    s = s % 60
  }
  if (m >= 60) {
    h = Math.floor(m / 60)
    m = m % 60
  }
  if (h >= 24) {
    d = Math.floor(h / 24)
    h = h % 24
  }

  if (mode === 'zh-cn') {
    if (d > 0) {
      if (d < 2) {
        R = d * 24 + h + '小时' + pad(m) + '分' + pad(s) + '秒'
      } else {
        R = d + '天' + h + '小时' + pad(m) + '分' + pad(s) + '秒'
      }
    } else if (h > 0) {
      R = h + '小时' + pad(m) + '分' + pad(s) + '秒'
    } else if (m > 0) {
      R = m + '分' + pad(s) + '秒'
    } else {
      R = s + '秒'
    }
  } else if (mode === 'auto') {
    if (d > 0) {
      R = d + '天'
    } else {
      R = pad(h) + ':' + pad(m) + ':' + pad(s) + ''
    }
  } else {
    if (d > 0) {
      R = d + '天' + pad(h) + ':' + pad(m) + ':' + pad(s) + ''
    } else {
      R = pad(h) + ':' + pad(m) + ':' + pad(s) + ''
    }
  }

  // console.log(R);

  return R
}

export function getQuery(name) {
  const Q = q2o(location.search.slice(1))
  // alert(JSON.stringify(Q, null, 2))
  return name ? Q[name] : Q
}

export function diffUpDown(target, my) {
  target = +target
  my = +my
  if (my > target) {
    return 'up'
  } else if (my < target) {
    return 'down'
  }
  return 'none'
}

export function noop() {}

export function delay(ms) {
  return new Promise(resolve => {
    setTimeout(() => resolve(true), ms)
  })
}

export function listToMapByKey(list, key) {
  return list.reduce((a, c) => {
    a[c[key]] = c
    return a
  }, {})
}

export function setArrayReactive(arr, index, val) {
  arr.splice(index, 1, val)
}

//********************获取n天之后的时间函数********************************************
export function GetDateStr(AddDayCount) {
  var dd = new Date(XUtils.now(true))
  dd.setDate(dd.getDate()+AddDayCount)//获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = (dd.getMonth()+1)<10?'0'+(dd.getMonth()+1):(dd.getMonth()+1)//获取当前月份的日期，不足10补0
  var d = dd.getDate()<10?'0'+dd.getDate():dd.getDate()//获取当前几号，不足10补0
  return y+'-'+m+'-'+d
}
//********************分隔标准时间"2016-11-23"字符串***********************************
export function splitStandardTime(timeString){
	var sTime = new Date(Date.parse(timeString))
	var y = sTime.getFullYear()
	var m = (sTime.getMonth()+1)<10?'0'+(sTime.getMonth()+1):(sTime.getMonth()+1)
	var d = sTime.getDate()<10?'0'+sTime.getDate():sTime.getDate()
	// var h = sTime.getHours()<10?"0"+sTime.getHours():sTime.getHours();
	// var m = sTime.getMinutes()<10?"0"+sTime.getMinutes():sTime.getMinutes();
	// var s = sTime.getSeconds()<10?"0"+sTime.getSeconds():sTime.getSeconds();
	return {y : y, m : m,d : d}
}
/* *******************格式化时间********************* */
export function dataFormat (d, f) { //传入yyyy-MM-dd hh:mm:ss
  var date = new Date(d)
  var fmt = f ? f : 'yyyy-MM-dd'
	var o = {
    'M+': date.getMonth() + 1, //月份
    'd+': date.getDate(), //日
    'h+': date.getHours(), //小时
    'm+': date.getMinutes(), //分
    's+': date.getSeconds(), //秒
    'q+': Math.floor((date.getMonth() + 3) / 3), //季度
    'S': date.getMilliseconds() //毫秒
	}
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
	for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
	return fmt
}
//********************获取当前时间******************************************************
export function get_now_time(){
	var mydate = new Date(XUtils.now(true)), R = {}
	R.years = mydate.getFullYear()
	R.months = (mydate.getMonth()+1)<10?'0'+(mydate.getMonth()+1):(mydate.getMonth()+1) //获取当前月份(0-11,0代表1月)
	R.days = mydate.getDate()<10?'0'+mydate.getDate():mydate.getDate() //获取当前日(1-31)
	R.times = mydate.getTime() //获取当前时间(从1970.1.1开始的毫秒数)
    //alert(mydate.getDate());
    return R
}